import {
  Box,
  Button,
  Chip,
  Divider,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import { FunctionComponent } from "react";
import {
  NewsCategory,
  NewsItem,
  newsReleases,
  upcomingNews,
} from "./news.data";
import { reopenWhatsNew } from "./WhatsNewDialog";

interface OwnProps {}
export type Props = OwnProps;

const categoryColor: Record<
  NewsCategory,
  "primary" | "info" | "warning" | "error"
> = {
  Novità: "primary",
  Miglioramento: "info",
  Correzione: "warning",
  Sicurezza: "error",
};

const NewsCard: FunctionComponent<{ item: NewsItem }> = ({ item }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      mb: 2,
      borderRadius: 2,
      border: (t) => `1px solid ${t.palette.divider}`,
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 1,
        flexWrap: "wrap",
      }}
    >
      <Chip
        label={item.category}
        color={categoryColor[item.category]}
        size="small"
        variant="filled"
      />
      <Typography variant="h6" fontWeight={700}>
        {item.title}
      </Typography>
    </Box>
    <Typography variant="body1" color="text.secondary">
      {item.description}
    </Typography>
  </Paper>
);

const News: FunctionComponent<Props> = () => {
  const theme = useTheme();

  return (
    <Box sx={{ maxWidth: 820, mx: "auto", py: { xs: 2, md: 4 }, px: 2 }}>
      <Typography variant="h3" fontWeight={800}>
        Novità
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
        Tutti gli aggiornamenti e i miglioramenti di Mia Reputation, in ordine
        di tempo.
      </Typography>

      {/* Chi ha chiuso l'annuncio al primo accesso deve poterlo rivedere: senza questo
          il riassunto delle ultime novita' e' consultabile una volta sola. */}
      <Button
        size="small"
        startIcon={<ReplayRoundedIcon />}
        onClick={reopenWhatsNew}
        sx={{ mb: 4 }}
      >
        Rivedi il riassunto delle ultime novità
      </Button>

      {newsReleases.map((release, idx) => (
        <Box key={idx} sx={{ mb: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              mb: 2,
            }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                bgcolor: theme.palette.primary.main,
                flexShrink: 0,
              }}
            />
            <Typography variant="h5" fontWeight={700}>
              {release.date}
            </Typography>
            {release.headline && (
              <Typography variant="subtitle1" color="text.secondary">
                — {release.headline}
              </Typography>
            )}
          </Box>
          {release.items.map((item, i) => (
            <NewsCard key={i} item={item} />
          ))}
        </Box>
      ))}

      {upcomingNews.length > 0 && (
        <>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
            Prossimamente
          </Typography>
          {upcomingNews.map((item, i) => (
            <NewsCard key={i} item={item} />
          ))}
        </>
      )}
    </Box>
  );
};

export default News;
